import { useEffect, useRef } from 'react';

import { SCAN_EVENT_QUEUE } from '../constants/scanEventQueue.const';
import { closePopovers } from '../utils/closePopovers.util';
import { createRawScanEvent } from '../utils/createRawScanEvent.util';
import { createScanDetector } from '../utils/scanDetector.util';
import { useScanTelemetry } from './useScanTelemetry';

/**
 * Mounts scan detection and enqueues raw events. Scans the queue rejects are
 * reported through the scan telemetry.
 */
export const useScanDetection = () => {
  const scanTelemetry = useScanTelemetry();
  const scanTelemetryRef = useRef(scanTelemetry);
  scanTelemetryRef.current = scanTelemetry;

  useEffect(() => {
    const detector = createScanDetector({
      onScan: (barcodeValue) => {
        closePopovers();
        const rawScanEvent = createRawScanEvent(barcodeValue);
        const { status } = SCAN_EVENT_QUEUE.enqueue(rawScanEvent);

        if (status !== 'accepted') scanTelemetryRef.current.trackSuppressed(rawScanEvent, status);
      },
    });

    detector.start();

    return detector.stop;
  }, []);
};
